import React, { useEffect } from 'react'
import { Container, AdditionalInformationContainer, ErrorTitle, ErrorDescription } from './styles'
import { CheckUpGrid } from '../CheckUpGrid'
import { LegendCriteria } from '../LegendCriteria'
import { Disclaimer } from '../Disclaimer'
import { IconComponent } from '~/assets/icons/component'
import { useCheckUp, usePatient } from '~/context'
import { SpinnerIconLoader } from '~/components/shared'
import { defaultCheckUpRequestParams } from '~/constants/checkUp'
import { Stack } from '~/styles'
import { message } from '~/services'

export const Content = (): JSX.Element => {
  const { getVisiblePatientId } = usePatient()
  const { getCheckUpProperties, isLoadingCheckUp, errorCheckup } = useCheckUp()

  useEffect(() => {
    const patientId = getVisiblePatientId()
    if (patientId) {
      getCheckUpProperties({ pathParams: { patientId }, queryParams: { ...defaultCheckUpRequestParams } })
    }
  }, [getCheckUpProperties, getVisiblePatientId])

  if (isLoadingCheckUp) {
    return (
      <AdditionalInformationContainer>
        <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
      </AdditionalInformationContainer>
    )
  }

  if (errorCheckup) {
    return (
      <AdditionalInformationContainer>
        <IconComponent name="worksheets" />
        <ErrorTitle>{message('analyticalModels.not_found_title')}</ErrorTitle>
        <ErrorDescription>{errorCheckup}</ErrorDescription>
      </AdditionalInformationContainer>
    )
  }

  return (
    <Container>
      <Stack>
        <CheckUpGrid />
        <Disclaimer />
      </Stack>
      <LegendCriteria />
    </Container>
  )
}
